import { OverlayPopupMenu } from 'features/overview'
import { usePointCloudContext } from 'features/pointClouds'
import React, { FC, useRef } from 'react'

import { PointCloudSettingsEditor } from './PointCloudSettingsEditor'
export const PointCloudPopupMenus: FC = () => {
  const {
    showEditPointCloudConfigPopupMenu,
    setShowEditPointCloudConfigPopupMenu,
  } = usePointCloudContext()

  const editPointCloudConfigPopupRef = useRef<HTMLDivElement | null>(null)
  const popups = [editPointCloudConfigPopupRef]

  return (
    <>
      {showEditPointCloudConfigPopupMenu && (
        <OverlayPopupMenu
          getDraggableGroup={() => popups}
          assignRef={editPointCloudConfigPopupRef}
          title={'Edit Point Cloud Config'}
          closeFunction={() => setShowEditPointCloudConfigPopupMenu(undefined)}
          startPosition={showEditPointCloudConfigPopupMenu}>
          <PointCloudSettingsEditor />
        </OverlayPopupMenu>
      )}
    </>
  )
}
